/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Segment_InvalidInputs */



/**
* | output |
* | --- |
* | "Segment is invalid - start must be earlier than end, and both must be inside the video." |
*
* @param {Sd_Segment_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_segment_invalid = /** @type {((inputs?: Sd_Segment_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Segment_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le segment est invalide : le début doit être antérieur à la fin, et les deux doivent se trouver à l’intérieur de la vidéo.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Segment ist ungültig – der Startpunkt muss vor dem Ende liegen, und beide müssen innerhalb des Videos liegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il segmento non è valido: l'inizio deve essere precedente alla fine ed entrambi devono trovarsi all'interno del video.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Недопустимый сегмент — начало должно быть раньше конца, и оба момента должны находиться внутри видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El segmento no es válido: el inicio debe ser anterior al final, y ambos deben estar dentro del vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("片段无效——开始时间必须早于结束时间，并且两者都必须在视频内部。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントが無効です。開始位置は終了位置より前である必要があり、両方とも動画内に含まれていなければなりません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह सेगमेंट अमान्य है - शुरुआत अंत से पहले होनी चाहिए, और दोनों वीडियो के अंदर होने चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O segmento é inválido - o início deve ser anterior ao fim, e ambos devem estar dentro do vídeo.")
	return /** @type {LocalizedString} */ ("Segment is invalid - start must be earlier than end, and both must be inside the video.")
});